import { useState } from 'react';
import { Account } from '@adjust/dashboard-core/api/types';
import { User, UseCurrentUser } from '../types';
import { getCurrentUser, getCurrentAccount, logout, switchAccount, searchAccount } from '../helpers/api';
import { redirectToLogin } from 'src/helpers/utilities';

export const useCurrentUser = (): UseCurrentUser => {
  const [data, setData] = useState<{ user: User; account: Account }>();
  const [accounts, setAccounts] = useState<Account[]>([]);

  return {
    ...data,
    accounts,
    fetch: () =>
      Promise.all([getCurrentUser(), getCurrentAccount()]).then(([user, account]) => {
        setData({ user, account });
        return { user, account };
      }),
    logout: () => logout().then(redirectToLogin),
    switchAccount: accountId => {
      switchAccount(accountId).then(() => {
        window.location.reload();
      });
    },
    searchAccount: (query: string) =>
      searchAccount(query).then(accounts => {
        setAccounts(accounts);
        return accounts.map(account => ({
          value: account.id,
          label: account.name,
        }));
      }),
  };
};
